import Api from 'libs/api';
import AuthService from 'services/Auth';
import axios from 'axios';

class AdminOrdersApi extends Api {
  constructor(restaurantId) {
    const resId = restaurantId || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/orders`);
  }

  getExcel = (params = {}) => {
    return axios({
      url: `${this.url}.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }
}

export default AdminOrdersApi;
